<template>
    <div id="charts_wrapper">
        <div class="pt-8">
            <v-card class="basic_chart" elevation="2" width="70%">
                <v-card-title class="mb-3"><h3>Yearly Projects Comparision</h3></v-card-title>
                <v-card-text>
                    <YearlyProjectsComparision
                        v-if="yearlyProjectsData.length > 0"
                        :yearlyProjectsComparisonData="yearlyProjectsData"
                        :serviceModules="serviceModules" />
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'

    import YearlyProjectsComparision from './charts/yearly_projects_comparison.vue'

    export default {
        components: {
            YearlyProjectsComparision,
        },

        data: () => ({
            yearlyProjectsData: [],
            serviceModules: [
                { service: 'Contingency',           moduleIds: ['44c575f7-731c-4e25-b29a-e54394284b62', 'fae01096-368d-4a67-b055-a8e3fdc17147', 'c1113507-6b0b-4cdc-9b7b-579492e083ef'] },
                { service: 'Deal Support',          moduleIds: ['38b13ea0-5991-4a37-ba22-3109b497c347', '57d342e7-f928-47ee-84b2-fa76f0b8a912', '34bf9b73-1ec5-48aa-8bc8-634eb8855d36'] },
                { service: 'Employment Resources',  moduleIds: ['2fec8290-ddc5-4051-aec7-31ef0af58443', '01f6cfd9-43bd-418e-9557-5351ff6c612e', '82734099-1c53-4e9e-ac55-f1c757da53fc'] },
                { service: 'Entity Maintenance',    moduleIds: ['8210bdc5-7f6c-4e19-8554-f007564e048d'] },
                { service: 'Entity Support',        moduleIds: ['fc81ca27-6f2e-4f06-a6d0-2943173c4e6e', 'ea18d255-2809-49ab-a91f-fe845d2d3f9e', '5955506b-fc78-47c4-9a6d-c36db9dc94f3'] },
                { service: 'Equity Sharing Plan',   moduleIds: ['44edf507-bf73-4859-8ee0-237e66633b78', 'e9931b28-f3be-4cf9-b36a-51a5ed54b21e'] },
                { service: 'HR Solutions: Comp',    moduleIds: ['bcd0cfdb-e0ea-4c9d-8b7f-56208c2d68b2', '8f0ed287-e23e-4609-a3dd-dbe10c3cfd7f', 'aa851ccc-9f7f-47ae-9ea9-ec1860ce72a5'] },
                { service: 'Merger',                moduleIds: ['9b20f06f-66be-4378-b9f0-fda39727611e', '9d5389d1-167d-4bb5-bf8a-092f2b1f4bb8'] },
                { service: 'Seller Advocacy',       moduleIds: ['2b0dbca7-866b-4e2e-8a2e-1c2f5f54369e'] },
                { service: 'Succession Planning',   moduleIds: ['01df03c9-256c-4ded-9f1c-401d8d1e8b41', '2f70fcbb-6d73-4bb0-b1a9-fd07cb8f479c'] },
                { service: 'Valuation',             moduleIds: ['12394580-b3bd-4184-9b3d-b8305dd92cd9', '16f44fb2-707c-491c-bec3-570500849c41', '4a342182-b693-4dbc-9a7a-b3122290f21e'] },
            ]
        }),

        created () {
            document.title = `Charts Dashboard`;
        },

        mounted () {
            this.getYearlyProjectsData();
        },

        methods: {
            getYearlyProjectsData: async function () {
                try {
                    const get_data = await axios.get(`${appUrls.api}/api/admin/yearly_projects`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( get_data.data.outcome ) {
                        this.yearlyProjectsData = get_data.data.yearly_projects_data;
                    }
                } catch ( err ) {
                    console.log(err);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #charts_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 5rem 0 0 0;
        display: flex;
        flex-direction: column;
    }
    .basic_chart {
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/ChartDashboard.vue